import { defineComponent as _defineComponent } from 'vue'
import { computed, onBeforeMount, ref, watchEffect } from "vue";
import { useRoute } from "vue-router/composables";
import { useWindowResize } from "@/utils/useWindowSize";
import { getOneAffiliateInvoice, patchMyLeadgidInvoiceStatus } from "@/api/payout";
import { showServerError } from "@/utils";
import { translateAffiliateStatus } from "@/utils/translate";
import { IAffiliateInvoice } from "@/api/types/payout";
import PageLayout from "@/components_v3/layout/PageLayout.vue";
import BaseTooltip from "@/components-UI/BaseTooltip.vue";
import SvgMasterInvoice from "@/assets/icons/master-invoice.svg";
import BaseStatus from "@/components-UI/BaseStatus.vue";
import BaseButtonV2 from "@/components-UI/buttons/BaseButtonV2.vue";
import SvgFindConversions from "@/assets/icons/payout/find-conversions.svg";
import SvgPay from "@/assets/icons/payout/pay.svg";
import AffiliateInvoiceInfo from "@/components_v3/affiliate/invoices/AffiliateInvoiceInfo.vue";
import CrmPaymentsTable from "@/components_v3/affiliate/invoices/CrmPaymentsTable.vue";
import AffiliateChargeRequests from "@/components_v3/affiliate/invoices/AffiliateChargeRequests.vue";
import InvoiceLeadsTable from "@/components_v3/affiliate/invoices/InvoiceLeadsTable.vue";
import BaseEditableCard from "@/components-UI/BaseEditableCard.vue";
import BillsTable from "@/components_v3/affiliate/bills/BillsTable.vue";
import BaseConfirmModal from "@/components-UI/modals/BaseConfirmModal.vue";
import { useAffiliateInvoiceStore } from "@/store_v3/AffiliateInvoiceStore";
import { storeToRefs } from "pinia";
import store from "@/store";
import { USER_ROLES } from "@/mappings/user-roles";
import { updateQueryString } from "@/utils/updateQueryString";
import EarlyRelease from "@/components_v3/affiliate/invoices/EarlyRelease.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateInvoicePage',
  setup(__props) {

const route = useRoute();
const { width } = useWindowResize();
const { isNeedUpdateInvoice } = storeToRefs(useAffiliateInvoiceStore());

const invoiceId = computed(() => route.params.id);
const title = computed(() => `Счёт ${invoiceId.value}`);
const isMobile = computed(() => width.value <= 768);
const isLoading = ref(false);
const status = computed(() => translateAffiliateStatus(invoice.value.paid_status));
const isPaid = computed(() => invoice.value.is_paid);

const invoice = ref<IAffiliateInvoice>({} as IAffiliateInvoice);

onBeforeMount(() => {
    getInvoice();
    updateQueryString({});
});

watchEffect(() => {
    if (isNeedUpdateInvoice.value) {
        getInvoice();
        isNeedUpdateInvoice.value = false;
    }
});

const isAdminRole = computed(() => {
    const adminRoles = [USER_ROLES.ADMIN, USER_ROLES.SUPERVISOR];
    const user = store.getters['authModule/GET_USER'];
    return adminRoles.some(role => user.roles.includes(role));
});

const getInvoice = async () => {
    try {
        isLoading.value = true;
        invoice.value = await getOneAffiliateInvoice(invoiceId.value);
    } catch (err) {
        showServerError(err, 'Счёт не найден');
    } finally {
        isLoading.value = false;
    }
};

const findConversions = (): void => {
    const params = new URLSearchParams();
    params.append('offset', '0');
    params.append('affiliate_invoice_id', String(invoice.value.id));

    const columns = [
        'adv_sub', 'affiliate_id', 'affiliate_invoice_id', 'affiliate_name', 'click_id', 'client_id',
        'conversion_id', 'creation_date', 'currency', 'goal_id', 'goal_name', 'offer_id', 'offer_name',
        'payout', 'revenue', 'status',
    ];
    columns.forEach((col) => {
        params.append('columns', col);
    });

    const queryString = params.toString();
    window.open(`/statistics/conversions-report?${queryString}`, '_blank');
};

const confirmModal = ref(null);
const paidOperationHandler = async () => {
    try {
        const status = isPaid.value ? 'unpaid' : 'paid';
        const message = isPaid.value ? 'Отменить оплату счёта' : 'Оплатить счёт';
        const isConfirm = await confirmModal.value?.openModal(`${message} ${invoiceId.value}?`);
        if (isConfirm) {
            await patchMyLeadgidInvoiceStatus(invoiceId.value, { status });
            await getInvoice();
        }
    } catch (err) {
        showServerError(err, 'Статус не изменен');
    }
};


return { __sfc: true,route, width, isNeedUpdateInvoice, invoiceId, title, isMobile, isLoading, status, isPaid, invoice, isAdminRole, getInvoice, findConversions, confirmModal, paidOperationHandler, PageLayout, BaseTooltip, SvgMasterInvoice, BaseStatus, BaseButtonV2, SvgFindConversions, SvgPay, AffiliateInvoiceInfo, CrmPaymentsTable, AffiliateChargeRequests, InvoiceLeadsTable, BaseEditableCard, BillsTable, BaseConfirmModal, EarlyRelease }
}

})